import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand aos-robustand p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Our End-to-End App Store Optimization Services</h2>
            <p>User retention, monetization, or install-to-engagement ratio – no matter what you aim for, our multi-phase ASO services cover everything. Upscale your performance and growth metrics with top-tier app store optimization efforts.</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Start with a Free Consultation
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>App Audit & Optimization</h4>
                  <p>Our ASO services start with a comprehensive audit of your app’s performance on the App Store and Google Play, analyzing competitors, market trends, and user behavior. Our optimization strategies include keyword refinement, metadata enhancement, and targeted improvements to boost visibility and installs.</p>
                </div>
                <div className="robust-content">
                  <h4>Competitor Analysis & Benchmarking</h4>
                  <p>Gain a competitive edge with a detailed analysis of your app’s rivals. We evaluate competitor strategies, identify market gaps, and benchmark your app’s performance to make your app stand out in a crowded marketplace.</p>
                </div>
                <div className="robust-content">
                  <h4>Keyword Research & Metadata Optimization</h4>
                  <p>Our ASO experts use advanced tools to develop a high-impact keyword strategy. We optimize your app’s metadata, including titles, descriptions, and tags, to enhance search rankings and increase organic installs.</p>
                </div>
                <div className="robust-content">
                  <h4>A/B Testing & Visual Optimization</h4>
                  <p>Improve your app’s conversion rate with data-driven A/B testing of visual assets. We test and refine icons, screenshots, and videos to ensure they resonate with your target audience and drive higher download rates.</p>
                </div>
                <div className="robust-content">
                  <h4>App Launch Strategy & Support</h4>
                  <p>Maximize your app’s success at launch with our strategic support. We provide pre-launch audits, keyword strategies, and optimized metadata to ensure your app achieves high visibility and traction from day one.</p>
                </div>
                <div className="robust-content">
                  <h4>Ongoing ASO Management</h4>
                  <p>Our continuous ASO management service includes regular updates to keywords, metadata, and visual assets. We monitor performance metrics and adapt strategies to maintain your app’s competitive edge and drive sustained growth.</p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
